import { DirectSalesAllocationSolutionStatus } from 'components/common/types/DirectSalesAllocationSolution';
import { DirectSalesLineAllocation } from 'components/common/types/DirectSalesCampaign.types';

export type CriteriaAllocation = {
  allocated?: number;
  status?: DirectSalesAllocationSolutionStatus;
};

export const formatLineDataToAllocation = (
  lineAllocation: DirectSalesLineAllocation,
  objectiveId: number | null,
): CriteriaAllocation => {
  if (!objectiveId || !lineAllocation[objectiveId])
    return {
      allocated: undefined,
      status: undefined,
    };

  return {
    allocated: lineAllocation[objectiveId].allocated,
    status: lineAllocation[objectiveId].status,
  };
};
